import { Populares } from "../Productos/Populares";

export const Favoritos = () => {
  return (
    <>
      <Populares />
    </>
  );
};
